export default __webpack_public_path__ + "static/media/necrosis.68c68264.png";